"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var LoadingPillbox = function (props) {
    return (react_1.default.createElement("div", { className: "pillbox-label pillbox-label--slate loading-pillbox ".concat(props.className || "") },
        props.message ? "".concat(props.message, "... ") : "",
        props.percent,
        "%"));
};
exports.default = LoadingPillbox;
